import { render, staticRenderFns } from "./SignatureTemplate5.vue?vue&type=template&id=0016d428&"
import script from "./SignatureTemplate5.vue?vue&type=script&lang=js&"
export * from "./SignatureTemplate5.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports